import { jsx as o } from "react/jsx-runtime";
import { attributes as e } from "../utils/attributes.js";
import '../../assets/ButtonIcon.css';function s({
  Icon: n,
  onClick: r,
  style: i,
  onMouseEnter: u,
  onMouseLeave: a,
  disabled: t = !1,
  variant: c = "big"
}) {
  return /* @__PURE__ */ o(
    "button",
    {
      className: `buttonIcon buttonIcon--${c}`,
      onMouseEnter: u,
      onMouseLeave: a,
      onClick: r,
      style: i,
      ...e({ disabled: t, "aria-disabled": t }),
      children: /* @__PURE__ */ o(n, {})
    }
  );
}
export {
  s as ButtonIcon
};
//# sourceMappingURL=ButtonIcon.js.map
